import { spawn, call, takeLatest, put, all } from 'redux-saga/effects';
import api from '../../../api';
import { parametrosActions } from '../../../../application/actions/parametros';

const apiParametros = api(process.env.REACT_APP_URL);

export function* fetchParametros(params) {
  try {
    const { lista, parametro } = params.payload;
    const token = '123456789';
    // 'Authorization': `Bearer ${token}`
    const optionalsHeaders = {
      Authorization: `Bearer ${token}`,
    };

    let url = `parametro/${lista}`;
    if(parametro !== undefined){
      url = `${url}?${parametro}`;
    }

    const { data } = yield call(apiParametros.get, url, '' , optionalsHeaders);

    if (data) {
      yield put(parametrosActions.validarParametros({ responseParametros: data, nombreLista: lista }));
    } else {
      yield put(parametrosActions.validarParametrosError({ responseParametros: { code: -1 } }));
    }
  } catch {
    yield all([
        put(parametrosActions.validarParametrosError())
    ]);
  }
}

export function* watchFetchVerificacion() {
    yield takeLatest(parametrosActions.parametrosServicio.type, fetchParametros);
}

export default function* rootSaga() {
    yield spawn(watchFetchVerificacion);
}
